//
// Telemetry recorder.
// TODO: Keep track of time.
function ANTelemetryRevenueRecorder(eventName, intervalTimeInMinutes = 0.5, reduceSendFrequency = true, onlySendOneIntervalEvent = true, brandsServingVideosOutsideOfGAM = []){

    this.__brandsServingVideosOutsideOfGAM = brandsServingVideosOutsideOfGAM;
    this.__version                         = '2';
    this.__eventName                       = eventName;
    this.__interval                        = null;
    this.__logger                          = new AdsNinjaLogger();
    this.__brandName                       = window.adsNinjaHeaderBiddingManager.getBrandName();
    this.__waitingResponse                 = false;
    this.__reduceSendFrequency             = reduceSendFrequency;
    this.__isEnabledForBrand               = null;
    this.__hasDataToSend                   = false;
    this.__dataSent                        = [];
    this.__adUnitsBeingTracked             = {};
    this.__requestCounters                 = {};
    this.__impressionCounters              = {};
    var self                               = this;

    if(!this.isEnabledForBrand()){

        this.__logger.debug('Sending revenue telemetry records is disabled.', {
            eventName: this.__eventName,
        }, false);
        return;
    }
    else{

        this.__logger.debug('Sending revenue telemetry records is enabled.', {
            eventName: this.__eventName,
        }, false);
    }

    if(this.__reduceSendFrequency && !this.__brandsServingVideosOutsideOfGAM.includes(this.__brandName)){

        if(onlySendOneIntervalEvent){

            // Send event one time.
            setTimeout(function(){

                self.handleTimeToSendData(`time`);
            }, intervalTimeInMinutes * 60 * 1000);

        }
        else{
        
            // Send events at interval time.
            this.__interval = setInterval(function(){
                
                self.handleTimeToSendData('time');
            }, intervalTimeInMinutes * 60 * 1000);

        }
    }

    // Setup event listeners.
    window.addEventListener('beforeunload', this.handleTimeToSendData.bind(this, 'beforeunload'));
    window.addEventListener('pagehide', this.handleTimeToSendData.bind(this, 'pagehide'));
    window.addEventListener('visibilitychange', function(){

        if('visible' === document.visibilityState){

            return;
        }

        self.handleTimeToSendData('visibilitychange');
    });
}

//
// Reset counters.
ANTelemetryRevenueRecorder.prototype.__reset = function(){

    this.__requestCounters    = {};
    this.__impressionCounters = {}; 
};

//
// Increment counter.
ANTelemetryRevenueRecorder.prototype.recordImpression = function(adUnitName, biddingLibrary, bidder, cpm, recordingOptions = {}, bidLifeTime = null){
    
    this.__hasDataToSend = true;
    bidder               = `${biddingLibrary[0]}:${bidder}`;
    var hour             = this.getCurrentHour();

    if(!this.__impressionCounters.hasOwnProperty(hour)){

        this.__impressionCounters[hour] = {};
    }

    if(!this.__impressionCounters[hour].hasOwnProperty(adUnitName)){

        this.__impressionCounters[hour][adUnitName] = {};
    }      

    if(!this.__impressionCounters[hour][adUnitName].hasOwnProperty(bidder)){

        this.__impressionCounters[hour][adUnitName][bidder] = {
            'imps': 0,
            'totalCpm': 0,
            'totalBidLifeTime': 0,
        };
    }

    this.__impressionCounters[hour][adUnitName][bidder]['imps']     += 1;
    this.__impressionCounters[hour][adUnitName][bidder]['totalCpm'] += cpm;

    if(bidLifeTime !== null){
        this.__impressionCounters[hour][adUnitName][bidder]['totalBidLifeTime'] += bidLifeTime;
    }

    // this.__logger.debug('Telemetry Revenue Recorder: Added impression.', {
    //     impressionData: this.__counters[key]
    // }); 

    if(this.__brandsServingVideosOutsideOfGAM.includes(this.__brandName)){

        this.handleTimeToSendData("impression", recordingOptions);
    }
};

//
// Increment counter.
ANTelemetryRevenueRecorder.prototype.recordRequest = function(adUnitName, bidders, recordingOptions = {}){

    this.__hasDataToSend = true;
    var hour             = this.getCurrentHour();

    if(!this.__requestCounters.hasOwnProperty(hour)){

        this.__requestCounters[hour] = {};
    }

    if(!this.__requestCounters[hour].hasOwnProperty(adUnitName)){

        this.__requestCounters[hour][adUnitName] = {};
    }     

    var prebidBidders = Object.values(bidders['prebid']).map(function(bidder){ return `p:${bidder}` }).join(',');
    var amazonBidders = Object.values(bidders['amazon']).map(function(bidder){ return `a:${bidder}` }).join(',');
    var gamBidders    = Object.values(bidders['gam']).map(function(bidder){ return `g:${bidder}` }).join(',');
    bidders           = (prebidBidders && amazonBidders && gamBidders) ? `${prebidBidders},${amazonBidders},${gamBidders}` : 'unknown';

    if(!this.__requestCounters[hour][adUnitName].hasOwnProperty(bidders)){

        this.__requestCounters[hour][adUnitName][bidders] = 0;
    }

    this.__requestCounters[hour][adUnitName][bidders] += 1;

    //     this.__logger.debug('Telemetry Revenue Recorder: Added request.', {
    //         adUnitName: adUnitName,
    //         requestData: this.__counters[matchingKeyFound]
    //     });

    if(this.__brandsServingVideosOutsideOfGAM.includes(this.__brandName)){

        this.handleTimeToSendData("request", recordingOptions);
    }

};

//
// Success callback.
ANTelemetryRevenueRecorder.prototype.__successCallback = function(response){

    this.__logger.debug('Telemetry Revenue Recorder: Sent telemetry event.', {
        response: response,
        eventName: this.__eventName,
        counters: self.__counters,
    });
};

//
// Error callback.
ANTelemetryRevenueRecorder.prototype.__errorCallback = function(status, response, isSendingDisabled){

    if(!isSendingDisabled){

        this.__logger.error('Failed to send telemetry event.', {
            status: status,
            response: response,
            eventName: this.__eventName,
            counters: self.__counters,
        });
    }
    else{

        this.__logger.debug('Failed to send telemetry event. Telemetry is disabled.', {
            status: status,
            response: response,
            eventName: this.__eventName,
            counters: self.__counters,

        });
    }

    // TODO: Retry logic.
};

//
// Handle time to send data.
ANTelemetryRevenueRecorder.prototype.handleTimeToSendData = function(initiator, recordingOptions = {}){

    // if(this.isEnabledForBrand() 
    //     && this.__hasCounters
    //     && !this.__waitingResponse 
    //     && 'TheThings' === this.__brandName 
    //     && initiator.indexOf('time') === -1
    // ){

    //     // Send event to server.
    // }
    
    if(!this.isEnabledForBrand() 
        // || !this.__hasCounters
        || !this.__hasDataToSend
        || this.__waitingResponse 
    ){

        return;
    }

    if(!window.adsNinja){

        this.__logger.error('AdsNinja queue is not defined.');
        return;
    }

    this.__waitingResponse = true;
    var counters           = {
        reqs: this.__requestCounters,
        imps: this.__impressionCounters,
    };
    var data               = {
        v: this.__version,
        eventName: this.__eventName,
        counts: JSON.parse(JSON.stringify(counters)),
        initiator: initiator,
    };

    this.__dataSent.push(data);

    window.adsNinja.sendTelemetryEvent(
        'data',
        `Number of "${this.__eventName}" events counted so far.`, 
        data,
        this.__successCallback.bind(this),
        this.__errorCallback.bind(this), 
        true,
        false,
        ['sessionId'],
        false,
        recordingOptions


    );

    this.__reset();

    this.__waitingResponse = false;
    this.__hasDataToSend   = false;
};

//
// Check if enabled for brand.
ANTelemetryRevenueRecorder.prototype.isEnabledForBrand = function(){

    if(null !== this.__isEnabledForBrand){

        return this.__isEnabledForBrand;
    }
    
    // TODO: Remove restriction for brands.
    if(this.__brandName && this.__brandsServingVideosOutsideOfGAM.includes(this.__brandName)){

        this.__isEnabledForBrand = true;
    }
    else{

        this.__isEnabledForBrand = false;
    }

    return this.__isEnabledForBrand;
};

//
// Get current hour in Montreal timezone.
ANTelemetryRevenueRecorder.prototype.getCurrentHour = function(){

    var date  = new Date();
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    return date.toISOString();
};

window.ANTelemetryRevenueRecorder = ANTelemetryRevenueRecorder;
